<div class="spec">
  <span class="spec__key">{{ key | translate }}</span>
  <span class="spec__value">{{ value | translate }}</span>
</div>
